import Button from '2-core-elements/Buttons/Button';
import LinkCTA from '2-core-elements/LinkCTA/LinkCTA';
import { type FC } from 'react';
import { getDefaultFilters } from '../ListingFilters/ListingFilterHelpers';
import ListingFilters, { type ListingFiltersProps } from '../ListingFilters/ListingFilters';
import { type Filter } from '../ListingFilters/ListingFiltersTypes';

export interface ListingHeaderProps extends Omit<ListingFiltersProps, 'filters'> {
    clearFilterLabel: string;
    applyFilterLabel?: string;
    filterModalButtonLabel?: string;
    filterModalHeadingLabel?: string;
    disabled?: boolean;
    title: string;
    filters?: Filter[];
    keepHeadingOnMobile?: boolean;
    onClearFilters?: () => void;
    resetMapZoomRef?: React.MutableRefObject<(() => void) | null>;
}

const ListingHeader: FC<ListingHeaderProps> = ({
    clearFilterLabel,
    applyFilterLabel,
    filterModalButtonLabel = 'Filter',
    filterModalHeadingLabel,
    activeFilters,
    filters,
    setActiveFilters,
    disabled,
    title,
    filterModalOpen,
    setFilterModalOpen,
    keepHeadingOnMobile,
    onClearFilters,
    resetMapZoomRef,
}) => {
    return (
        <div className={`listing-app-header`}>
            <div className={`listing-app-heading-container ${!keepHeadingOnMobile ? 'hidden-until-sm-max' : ''}`}>
                <h2 className="listing-app-heading">{title}</h2>
                {!!filters && !!filters.length && (
                    <LinkCTA
                        prefixIcon="restart"
                        skin="1"
                        onClick={(): void => {
                            setActiveFilters(getDefaultFilters(filters));
                            resetMapZoomRef?.current?.();
                            if (onClearFilters) {
                                onClearFilters();
                            }
                        }}
                        disabled={disabled}
                        className="hidden-until-sm-max"
                    >
                        {clearFilterLabel}
                    </LinkCTA>
                )}
            </div>
            {!!filters && !!filters.length && (
                <div className="listing-app-filters">
                    <Button
                        className="listing-app-filters-modal-btn hidden-md" fullWidth={true} onClick={(): void => {
                            setFilterModalOpen(true);
                        }}
                        suffixIcon="discover-tune"
                    >{filterModalButtonLabel}
                    </Button>
                    <ListingFilters
                        filters={filters}
                        activeFilters={activeFilters}
                        setActiveFilters={setActiveFilters}
                        disabled={disabled}
                        filterModalOpen={filterModalOpen}
                        setFilterModalOpen={setFilterModalOpen}
                        clearFilterLabel={clearFilterLabel}
                        applyFilterLabel={applyFilterLabel}
                        filterModalHeadingLabel={filterModalHeadingLabel}
                        resetMapZoomRef={resetMapZoomRef}
                    />
                </div>
            )}
        </div>
    );
};

export default ListingHeader;
